export const ownTractorSurveySteps = {
  STEP1: 'step1',
  STEP2: 'step2',
};
